export interface FormValuesInterfce {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export const initialValues = {
  name: '',
  email: '',
  subject: '',
  message: '',
};
